module.exports = __webpack_public_path__ + "img/no-smoking-icon.1672e8cb.svg";